module.exports = __webpack_public_path__ + "static/img/4.3861052.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/eng/4.png
// module id = meiW
// module chunks = 0